var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStargray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9316 3.5916L12.4541 5.17493C12.6902 5.90777 13.3704 6.40596 14.1404 6.40993H15.787C16.5593 6.40503 17.2459 6.90048 17.4847 7.63493C17.7235 8.36937 17.4595 9.17391 16.832 9.6241L15.4783 10.6058C14.8551 11.0582 14.5932 11.8598 14.8291 12.5928L15.3516 14.1762C15.61 14.9117 15.3577 15.7298 14.7299 16.192C14.1021 16.6543 13.246 16.6522 12.6204 16.187L11.2904 15.1974C10.6669 14.7458 9.82382 14.7458 9.20036 15.1974L7.87036 16.187C7.24822 16.6424 6.40316 16.6436 5.77973 16.19C5.15629 15.7364 4.89734 14.932 5.13911 14.1999L5.66161 12.6166C5.8975 11.8835 5.63561 11.0819 5.01244 10.6295L3.62703 9.63201C2.9868 9.18089 2.71833 8.36321 2.96655 7.62039C3.21476 6.87757 3.92088 6.38554 4.70369 6.40993H6.35036C7.11606 6.40821 7.79499 5.91734 8.03661 5.19076L8.55911 3.60743C8.79334 2.8761 9.47169 2.37862 10.2396 2.37502C11.0075 2.37141 11.6905 2.86249 11.9316 3.5916Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStargray);
export default __webpack_public_path__ + "static/media/stargray.c634bcee71072d7f0dec144ed7798f32.svg";
export { ForwardRef as ReactComponent };